export default __webpack_public_path__ + "static/Education-631da7743150f321181add31e11ed96e8a6c28560040fc18fd118e3871aa6a3a.png";